export default __webpack_public_path__ + "static/media/flame.13e6f6d5.svg";